import styled from 'styled-components';

export const TopBannerSection = styled.section`
    
    .advertising-banner{
        padding-top: 60px;

        @media screen and (max-width: 1024px){
            padding-top: 160px;
        }
    }
`;

export const AdvertisingSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;
`;
export const AdvertisingWrap = styled.div`
    width: 100%;
    background: #FFFFFF;
    margin-top: -125px;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0px 20px 20px #0000001A;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 68px;

    @media screen and (max-width: 991px){
        flex-direction: column-reverse;
        row-gap: 30px;
    }

    @media screen and (max-width: 767px){
        padding: 20px;
    }
`;
export const AdvertisingContent = styled.div`
    width: calc(50% - 10px);
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 991px){
        width: 100%;
    }
`;
export const AdvertisingImageBox = styled.div`
    width: calc(50% - 10px);
    border-radius: 6px;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
      @media screen and (max-width: 991px){
        width: 100%;
    }  
`;
export const AdvertisingTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 15px;
    margin-top: 35px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
     
    @media screen and (max-width: 480px){
        font-size: 20px;
        line-height: 30px;
    }

    &:first-child{
        margin-top: 0px;
    }s
`;
export const AdvertisingText = styled.p`
    margin-bottom: 10px;
    &:last-child{
        margin-bottom: 0px;
    }
    a{
        color: #333;
       text-decoration: none;  
     }
`;
export const AdvertisingTextAnchor = styled.a`
    color: #01606F;
    font-weight: 600;
    text-decoration: none;
    a{
    color: #01606F;
    font-weight: 600;
    text-decoration: none;  
    }
`;
export const AdvertisingTextStrong = styled.strong`
    color: #333333;
    font-weight: 700;
`;
export const AdvertisingTableSection = styled.section`
    width: 100%;
`;